import { ItiMessageService } from "@/iti-core-react/services/iti-message-service";
import { PayloadAction, ThunkAction } from "@reduxjs/toolkit";
import { t } from "i18next";
import { RootState } from "../index";
import navigationBlockSlice from "./navigationBlockSlice";

export const navigationBlockActions = navigationBlockSlice.actions;

export const setNavigationBlocked: any =
	(
		value: boolean,
	): ThunkAction<void, RootState, unknown, PayloadAction<boolean>> =>
	async (dispatch) => {
		dispatch(navigationBlockActions.setNavigationBlocked(value));
	};

export const showNavigationBlockedMessage: any =
	(): ThunkAction<
		Promise<boolean>,
		RootState,
		unknown,
		PayloadAction<boolean>
	> =>
	async (dispatch, getState) => {
		const { isNavigationBlocked } = getState().navigationBlock;

		if (!isNavigationBlocked) return true;

		try {
			const result: any = await ItiMessageService.confirmAcceptCancelButtons(
				t("messages.back-with-pending-changes"),
			);

			if (result.result) {
				dispatch(navigationBlockActions.setNavigationBlocked(false));
			}
			return result.result;
		} catch (error) {
			return false;
		}
	};
